<script setup lang="ts">
import {ref, watch} from "vue";
import {getNonMemberGroups as apiGetNonMemberGroups} from "@/Services/Admin/admin-groups";
import {storeMemberGroups} from "@/Services/Admin/admin-group-members";
import {saving} from "@/Composables/api";
import {AutoComplete, Button, Dialog, Label} from "@/Components/Library";
import {Messages} from "@/Components/Forms";
import {useMainStore} from "@/Stores/store";

const $store = useMainStore();
const bag = "admin-user-groups-add";

const model = defineModel<boolean>("visible");

const props = defineProps<{
    currentUser?: {
        id: string;
        name: string;
    };
}>();

const emit = defineEmits(["added"]);

const groups = ref([]);

const getGroups = async () => apiGetNonMemberGroups(props.currentUser.id).then(({data}) => (groups.value = data));

const selectedGroups = ref([]);

const save = async () => {
    const data = await storeMemberGroups(props.currentUser.id, {
        groups: selectedGroups.value.map((group) => group.id),
    });

    selectedGroups.value = [];

    if (data.status === "success") {
        $store.addMessage({
            type: "success",
            text: "The user has been added to the groups successfully.",
            bag: bag,
        });
        emit("added");
        setTimeout(() => {
            model.value = false;
        }, 3000);
    }
};

watch(
    () => model.value,
    (visible) => {
        if (visible) {
            getGroups();
        }
    },
);
</script>
<template>
    <Dialog
        v-model:visible="model"
        modal
        :header="`Add ${currentUser?.name} to groups`"
        class="mx-8 max-h-dvh w-full overflow-y-auto sm:max-w-sm"
    >
        <form class="flex flex-col" @submit.prevent="save">
            <div class="mb-4 flex flex-col">
                <Label for="group" class="mb-1" required>Select groups</Label>
                <AutoComplete
                    input-id="group"
                    name="group"
                    v-model="selectedGroups"
                    :items="groups"
                    optionLabel="name"
                    placeholder="Select a group"
                    multiple
                    required
                />
            </div>
            <Messages :bag="bag" class="mb-4" />
            <Button :loading="!!saving" class="bg-askr-green text-white" type="submit">Add</Button>
        </form>
    </Dialog>
</template>
<style scoped></style>
